import { trigger, transition, style, query, animate, sequence } from "@angular/animations";

////////////////////////////////////////////////////////////
// Animation to put at start of other router transitions //
////////////////////////////////////////////////////////////
const resetRoute = [
  style({ position: "relative" }),
  query(
    ":enter, :leave",
    [
      style({
        position: "fixed", // using absolute makes the scroll get stuck in the previous page's scroll position on the new page
        top: 0, // adjust this if you have a header so it factors in the height and not cause the router outlet to jump as it animates
        left: 0,
        width: "100%",
        height: "100%",
        opacity: 0
      })
    ],
    { optional: true }
  )
];

///////////////////////
// Basic route Fader //
///////////////////////
export const routeFade = [
  trigger("routeFadeAnimation", [
    transition("* => *", [
      ...resetRoute,
      query(":enter", [style({ opacity: 0 })], {
        optional: true
      }),
      sequence([
        query(":leave", [style({ opacity: 1 }), animate("200ms 100ms ease", style({ opacity: 0 }))], {
          optional: true
        }),
        query(":enter", [style({ opacity: 0 }), animate("300ms 1s ease", style({ opacity: 1 }))], { optional: true })
      ])
    ])
  ])
];
